import * as $ from 'jquery';
import 'bootstrap';

export class enrichPromotionsToggleContent{
	private $toggleContainer = $('.enrich_promotionstoggle .enrichpromotions');
	private $curShown:any = [];

	showContentOnLoadHandler(): any {
		let _self = this;
		let togCont:any = _self.$toggleContainer;

		togCont.each((i:number, el:any) => {
			let jTogContainer:any = $(el);
			let toggleBtn:any   = jTogContainer.find('.btn-promotion-show-all');
			let curvalueEl:any  = jTogContainer.find('.cur_value');
			let maxvalue:string = jTogContainer.find('.max_value').text();
			let initShowVal:any = parseInt(curvalueEl.data('initShow'));
			let incrShowVal:any = parseInt(curvalueEl.data('incrementShow'));

			let hiddenCards:any   = jTogContainer.find('.enrichpromotions__item.hidden');
			let totCards:any   	  = jTogContainer.find('.enrichpromotions__item').length;

			// if (totCards < initShowVal) {
			// 	toggleBtn.hide();
			// 	return;
			// }

			// show all hidden cards
			for (var j=0, len=initShowVal; j<len; j++) {
				$(hiddenCards[j]).removeClass('hidden');
			}

			// update currently displayed value in results line
			// curvalueEl.text(initShowVal);

			_self.$curShown[i] = initShowVal;

			if (hiddenCards.length < incrShowVal) {
				toggleBtn.fadeOut();
				curvalueEl.text(maxvalue);
			} else {
				curvalueEl.text(_self.$curShown[i]);
			}

		});
	}

	/**
	 * initialize toggle container
	 * - attach event handler to 'show more' button in content
	 * - onclick display all hidden promotion cards
	 */
	initToggleContent(): any{
		let _self = this;
		let togCont:any = _self.$toggleContainer;

		togCont.each((i:number, el:any) => {
			let jTogContainer:any = $(el);
			let toggleBtn:any   = jTogContainer.find('.btn-promotion-show-all');
			let curvalueEl:any  = jTogContainer.find('.cur_value');
			let maxvalue:any    = jTogContainer.find('.max_value').text();
			let incrShowVal:any = curvalueEl.data('incrementShow');

			toggleBtn.on('click', function(e:any){
				e.preventDefault();
				e.stopPropagation();
				let hiddenCards:any   = jTogContainer.find('.enrichpromotions__item.hidden');

				// show all hidden cards
				for (var j=0, len=incrShowVal; j<len; j++) {
					if (hiddenCards[j] !== undefined) {
						$(hiddenCards[j]).removeClass('hidden');
					}
				}

				// update currently displayed value in results line
				_self.$curShown[i] += incrShowVal;

				// hide toggle button upon displaying all items
				if (_self.$curShown[i] >= maxvalue) {
					toggleBtn.fadeOut();
					curvalueEl.text(maxvalue);
				} else {
					curvalueEl.text(_self.$curShown[i]);
				}
			});
		});
	}
}

let scope:Element = document.querySelector('.enrich_promotionstoggle .enrichpromotions');
if (scope){
	try {
	let enrichpromotionstogglecontent = new enrichPromotionsToggleContent();
	enrichpromotionstogglecontent.showContentOnLoadHandler();
	enrichpromotionstogglecontent.initToggleContent();
	} catch(e) {console.error(e);}
}
